import React from 'react'
import { Header, Card, Grid } from 'semantic-ui-react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import insp1 from "../../../../../assets/images/insp1.png"
import insp2 from "../../../../../assets/images/insp2.png"
import insp3 from "../../../../../assets/images/insp3.png"
import insp4 from "../../../../../assets/images/insp4.png"
import "./Section2.css"
import { useTranslation } from 'react-i18next';

const Section2 = () => {
    const { t } = useTranslation()
    return <div className="Section2 p-1">
        <Header className="p-1-t p-1-b" size='huge'>
            {t("home:InspirationForYourNextTrip")}
            </Header>
        <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            navigation
            spaceBetween={5}
            slidesPerView={1}
            loop={true}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
        >
            <SwiperSlide><Card
                image={insp1}
                header={t("home:Gilan")}
                description='300 kilometers away'
                className="rounded-20 bg-orange w-100"

            /></SwiperSlide>
            <SwiperSlide><Card
                image={insp2}
                header={t("home:Gilan")}
                description='300 kilometers away'
                className="rounded-20 bg-orange w-100"

            /></SwiperSlide>
            <SwiperSlide><Card
                image={insp4}
                header={t("home:Gilan")}
                description='300 kilometers away'
                className="rounded-20 bg-orange w-100"

            /></SwiperSlide>
        </Swiper>


    </div>
}
export default Section2